import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'
import { type DocumentRecord } from '../../../models/Document'
import { type User } from '../../../models/User'

export const getDocumentSummaryTitle = (document: DocumentRecord, contact: User) => {
  const { label } = document.typeProcessing
  const contactName = getUserDisplayName(contact)

  return label ? `${label} - ${contactName}` : contactName
}
